import { useSiteStylesState } from '@/stores/site-styles-store';
import type { ButtonShape, ButtonStyle } from '@/types/shared';
import { usePublicDesignSettings } from './use-public-design-settings';

export interface SiteButtonSettings {
  shape: ButtonShape | undefined;
  buttonStyle: ButtonStyle | undefined;
}

export function useSiteButtons(): SiteButtonSettings {
  const { draftButtons } = useSiteStylesState();
  const { buttons } = usePublicDesignSettings(draftButtons ? { buttons: draftButtons } : undefined);

  return {
    shape: buttons?.shape,
    buttonStyle: buttons?.style,
  };
}
